import React from 'react';
import SkillIcon from './SkillIcon';

// Currently just an alias of SkillIcon
const DutyFunctionIcon = ({ dutyFunction }) => <SkillIcon skill={dutyFunction} />;

export default DutyFunctionIcon;
